export const USER_PROPERTY_GROUP_NAME = 'Custom';

export const monitoringItemTypes = {
  string: 'string',
  number: 'number',
  bool: 'bool',
  json: 'json'
};

export const BOOLEAN_OPTIONS = [
  { id: true, name: 'true' },
  { id: false, name: 'false' },
  { id: null, name: 'null' }
];

export const ShapeTypes = {
  NONE: 'NONE',
  CIRCLE: 'CIRCLE'
};

export const graphicsTypes = [
  {
    label: 'None',
    value: ShapeTypes.NONE
  },
  {
    label: 'Circle',
    value: ShapeTypes.CIRCLE
  }
];

export const getShapeTitleById = value =>
  graphicsTypes.find(type => type.value === value)?.label || '';
